import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Template from '../../../../stateless/Popup/Template';
import styles from './styles.scss';

const propTypes = {
  featuredImage: PropTypes.string,
  medium: PropTypes.string,
  children: PropTypes.element.isRequired,
};

const defaultProps = {
  featuredImage: undefined,
  medium: undefined,
};

const Preview = ({ medium, children, featuredImage }) => (
  <div className={cx(styles.preview, 'theme')}>
    <div className={styles.previewModal}>
      <Template medium={medium} featuredImage={featuredImage}>
        {children}
      </Template>
    </div>
  </div>
);

Preview.propTypes = propTypes;
Preview.defaultProps = defaultProps;

export default Preview;
